export default __webpack_public_path__ + "static/media/Despoiler's Hood of the Dusk Rebellion.b93f25d9.jpg";